export default __webpack_public_path__ + "static/media/home-hotel-resort-img-02.bf6b9190.jpg";